import { Rings } from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DataLoading = () => {
  return (
    <div className="h-[100vh] flex items-center justify-center flex-col">
      <Rings
        height="200"
        width="200"
        color="#38D9A9"
        radius="12"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="rings-loading"
      />
      <h2 className="text-xl sm:text-3xl mb-2 -mt-[5px] text-own-secondary tracking-widest">
        Sohag Hossain Zayan
      </h2>
      <h3 className="text-lg sm:text-2xl text-own-secondary tracking-wider">
        Web Developer
      </h3>
    </div>
  );
};

export default DataLoading;
